import { CircularProgress, Button as MUIButton } from "@mui/material";
import PropTypes from "prop-types";

// Map Bootstrap-style variant to MUI variant and color
const getVariantAndColor = (variant) => {
  switch (variant) {
    case "primary":
      return { variant: "contained", color: "primary" };
    case "secondary":
      return { variant: "contained", color: "secondary" };
    case "danger":
      return { variant: "contained", color: "error" };
    case "outlined":
      return { variant: "outlined", color: "primary" };
    case "text":
      return { variant: "text", color: "primary" };
    default:
      return { variant: "contained", color: "primary" };
  }
};

// Map Bootstrap-style size to MUI size
const mapSize = (size) => {
  switch (size) {
    case "lg":
      return "large";
    case "sm":
      return "small";
    default:
      return "medium";
  }
};

const Button = ({
  variant = "primary",
  size = "medium",
  children,
  onClick = () => {},
  disabled = false,
  type = "button",
  loading = false,
  sx = {},
  startIcon = null,
  endIcon = null,
  iconLeft = null,
  iconRight = null,
  ...props
}) => {
  const { variant: muiVariant, color: muiColor } = getVariantAndColor(variant);
  const muiSize = mapSize(size);

  // Support both MUI native props (startIcon/endIcon) and custom aliases (iconLeft/iconRight)
  const finalStartIcon = startIcon || iconLeft;
  const finalEndIcon = endIcon || iconRight;

  // Build sx styles conditionally, merging with any passed sx
  const sxStyles = {
    ...(muiVariant === "contained" && { fontWeight: 600 }),
    ...(size === "lg" && { width: "100%", py: 1.5 }),
    ...sx,
  };

  return (
    <MUIButton
      variant={muiVariant}
      color={muiColor}
      size={muiSize}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      sx={sxStyles}
      startIcon={finalStartIcon}
      endIcon={finalEndIcon}
      {...props}
    >
      {loading && (
        <CircularProgress
          size={20}
          color="inherit"
          style={{ marginRight: 8 }}
        />
      )}
      {children}
    </MUIButton>
  );
};

Button.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  loading: PropTypes.bool,
  sx: PropTypes.object,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
};

export default Button;
